export const SUPPORT_EMAIL = 'support@viresmo.com';
export const SENTRY_DSN = 'https://fb18ac5172694d9e949fbe373c0c163f@o922682.ingest.sentry.io/5869744';
const STAGE = process.env.STAGE || 'development';
export const IS_PRODUCTION = STAGE === 'production';
export const APPLICATION_VERSION = require('./package.json').version;
